<template>
  <Modal :title="`表示する${target}を設定`" @close="$emit('close')">
    <template #content>
      <div class="main">
        <div class="title">
          <p>グラフと一覧に表示させる{{ target }}を選択してください。</p>
          <p>最大10件まで選択できます。</p>
        </div>
        <ul :class="['list', { half }]">
          <li v-for="({ id, name, icon }, key) of data" :key="key" class="item">
            <CheckBox
              v-model="afterSelectedIds"
              :value="id"
              :disabled="afterSelectedIds.length > 9 && !afterSelectedIds.includes(id)"
            >
              {{ toEllipsis(name, 50) }}
              <TagIcon v-if="icon" :id="icon" class="icon" />
            </CheckBox>
          </li>
        </ul>
      </div>
    </template>
    <template #footer-center>
      <Button @click="$emit('close')">戻る</Button>
      <Button primary @click="change" :disabled="!isModified || !afterSelectedIds.length">設定</Button>
    </template>
  </Modal>
</template>

<script>
import { isEqual, sortBy } from 'lodash'
import { toEllipsis } from '@/utils/string'
import Modal from '@/components/molecules/Modal'
import Button from '@/components/atoms/Button'
import CheckBox from '@/components/atoms/CheckBox'
import TagIcon from '@/components/icons/TagIcon'

export default {
  name: 'ItemSelectModal',
  components: {
    Modal,
    Button,
    CheckBox,
    TagIcon,
  },
  props: {
    target: { type: String, default: '' },
    data: { type: Array, default: () => [] },
    selectedIds: { type: Array, default: () => [] },
    half: { type: Boolean, default: false },
  },
  data() {
    return {
      afterSelectedIds: [],
    }
  },
  computed: {
    isModified() {
      return !isEqual(sortBy(this.selectedIds), sortBy(this.afterSelectedIds))
    },
  },
  mounted() {
    this.afterSelectedIds = [...this.selectedIds]
  },
  methods: {
    toEllipsis,
    async change() {
      this.$emit('close')
      this.$emit('change', this.afterSelectedIds)
    },
  },
}
</script>

<style lang="postcss" scoped>
.main {
  max-height: 552px;
  overflow-y: scroll;
  padding: 32px;
}

.title {
  margin-bottom: 24px;
}

.list {
  display: grid;
  gap: 16px 32px;

  &.half {
    grid-template-columns: repeat(auto-fit, 192px);
  }
}

.check-box {
  align-items: center;
  display: grid;
  grid-template-columns: auto 1fr;
  width: auto;
  >>> .label {
    align-items: center;
    display: grid;
    grid-gap: 0 8px;
    grid-template-columns: 1fr 16px;
    line-height: 1;
    padding-top: 0;
  }
}

.icon {
  fill: var(--very-dark-gray-2);
  height: 16px;
  width: 16px;
}
</style>
